export const enviroment = {
    production:false,
    // patient_assessment_experience_api:'http://localhost:3003'
    patient_assessment_experience_api:'https://dev-api.nixpend.com'
}